import React from 'react';
import styled, { css } from 'styled-components';
import { getRadiusStyleBoxValue } from '../helpers';
import { IExpandButtonComponentProps } from '../types';

const ExpandButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: absolute;
  bottom: -1px;
  left: 0;
  background: #fff;
  box-shadow: 0px -22px 15px -5px #fff;
  padding-bottom: 10px;
  border-radius: ${getRadiusStyleBoxValue(true)};

  @media screen and (min-width: 1024px) {
    bottom: 0;
  }
`;

const ExpandButtonUI = styled.button`
  border-radius: 8px;
  background: #fff;
  display: inline-grid;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  padding: 10px 12px;
  position: relative;
  width: 172px;
  font-size: 16px;
  line-height: 20px;
  ${({ theme }) => css`
    color: ${theme.primaryColor};
    border: 2px solid ${theme.primaryColor};
    text-transform: ${theme.btnTextTransform};
    font-weight: ${theme.btnTextWeigth};
  `};
`;

export const ExpandButton: React.FC<IExpandButtonComponentProps> = ({ showExpandButton, expandContent }) => {
  if (!showExpandButton) {
    return null;
  }

  return (
    <ExpandButtonContainer>
      <ExpandButtonUI onClick={expandContent}>Ver Mais</ExpandButtonUI>
    </ExpandButtonContainer>
  );
};

export default ExpandButton;
